import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: "/",
      name: "home",
      component: () => import("@/views/ChatManage.vue"),
      meta: {
        pageTitle: "Quản lí chat",
        breadcrumb: [
          {
            text: "Danh sách",
            active: true,
          },
        ],
      },
    },

    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/Login.vue'),
      meta: {
        layout: 'full',
        redirectIfLoggedIn: true,
      },
    },

    {
      path: '*',
      redirect: '/',
    },
  ],
})

router.beforeEach((to, _, next) => {
  const isLoggedIn = localStorage.getItem('accessToken')
  if (!to.meta.redirectIfLoggedIn && !isLoggedIn) {
    // Redirect to login if not logged in
    if (!isLoggedIn) return next({ name: 'login' })
  }

  if (to.meta.redirectIfLoggedIn && isLoggedIn) {
    return next({ name: 'home' })
  }
  return next()
})

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

export default router
